import { MoneyInput } from '@transferwise/components';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import debounce from '../../../resources/debounce';
import gs from '../../../resources/static/less/comparison-components.module.less';

import s from './AmountToSend.module.less';

class AmountToSend extends Component {
  constructor(props) {
    super(props);

    const { debounceAmountMillis, onChangeFinish } = props;
    this.debouncedOnChange = debounce(debounceAmountMillis, onChangeFinish);
  }

  onChangeEvent(inputValue, onChange) {
    onChange(inputValue);
    this.debouncedOnChange(inputValue);
  }

  render() {
    const { source, amount, onChange } = this.props;
    return (
      <div className={gs['size-1-of-1']}>
        <div
          className={`${s['comparison-money-input']} ${gs['form-group']} ${gs['form-group-lg']}`}
        >
          <label htmlFor="money-input">
            <FormattedMessage id="send-exactly" />
          </label>
          <MoneyInput
            amount={amount}
            onAmountChange={(input) => {
              input && this.onChangeEvent(input, onChange);
            }}
            selectedCurrency={{ currency: source }}
            currencies={[]}
          />
        </div>
      </div>
    );
  }
}

AmountToSend.propTypes = {
  source: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeFinish: PropTypes.func.isRequired,

  debounceAmountMillis: PropTypes.number,
};

AmountToSend.defaultProps = {
  debounceAmountMillis: 350,
};

export default AmountToSend;
